<template>
    <div>
        <div class="page_head">
            <div class="section_title">
                {{ board.name }}
            </div>
            <div class="page_content">
                <p>
                    {{ board.description }}
                </p>
            </div>
            <div class="head_button text_left">
                <button
                    class="btn btn_template btn_add"
                    type="button"
                    @click="$openModal('addPost')"
                >
                    הוסף משרה חדשה
                </button>
            </div>
        </div>
        <div class="page_body">
            <div class="no_posts_wrap">
                <div class="block_title">
                    עדיין לא התפרסמו משרות בעמוד
                </div>
                <div class="content">
                    המשיכו לעקוב, ממש בקרוב יתפרסמו ...
                </div>
                <div class="image_wrapper">
                    <picture v-full-image-path:assets="'no_posts_image.svg'" />
                </div>
            </div>

            <modal-add-post :board-id="board.id" />
        </div>
    </div>
</template>

<script>
import ModalAddPost from '@/components/modals/AddPost';

export default {
    components: {
        ModalAddPost
    },

    props: {
        board: {
            type: Object,
            required: true
        }
    }
};
</script>
